import apiUrl from '../../../constants';
import axios from 'axios';
//import Paginate from 'vuejs-paginate';
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import download from 'downloadjs';
import Pagination from './../shared/pagination'
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import JsonExcel from "vue-json-excel";
import Vue from "vue";
Vue.component("downloadExcel", JsonExcel);


export default {
	name: 'merchant',
	components: {
		//Paginate,
		BasicSelect,
		Pagination,
		Loader,
		DatePicker,
		JsonExcel,
		download,
	},
	data: function () {
		return {
			formattedDate: '',
			selectedmerchant: { value: '', text: '' },
			merchantList: [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }],
			merchantId: '',
			currentPage: 1,
			totalPage: 0,
			totalCount: 0,
			pageLimit: 50,
			// totalRows:0,
			// currentPage: 0,
			showSelectWarehouse: false,
			isLoading: false,
			showSelectClient: false,
			showSelectMerchant: false,
			searchFlag: false,
			// perPage: 50,
			// pageCount: 0,
			// pageno: 0,
			listWarehouseData: [],
			listClientData: [],
			listProductRackData: [],
			listMerchantData: [],
			warehouse: '',
			Merchant: '',
			WarehouseErr: '',
			MerchantErr: '',
			warehouseid: '',
			user_type: '',
			client: '',
			racktype: '',
			clientid: '',
			ClientErr: '',
			lineno: '',
			rackno: '',
			sectionid: '',
			listProductRackDataCsv: '',
			userid: '',
			rackutilized: ['Utilized', 'Not Utilized'],
			rackuti: '',
			listReportDataforxls: [],
			csvFieldsForXls: {},
			reportname: '',
			show: '',
			limitExeed: '',
			download: true,
			subinventory: '',
			getsubinventorydata: [],
			searchzone:'',
			listZoneData:[],

		}
	},
	filters: {
		moment: function (date) {
			if (date)
				return moment(date).format('DD-MM-YYYY');
			else {
				return '';
			}
		},
		capitalize: function (value) {
			if (!value) return ''
			value = value.toString()
			return value.charAt(0).toUpperCase() + value.slice(1)
		},
	},

	mounted() {
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		// this.getProductRackDatasearch();
		this.useremail = userdetail.email;
		var loginuseremail = userdetail.email;
		this.warehouseid = userdetail.warehouseid;
		//	this.warehouse = userdetail.warehouseid;
		this.clientid = userdetail.clientid;
		this.loginClientUserId = userdetail.clientid;
		this.loginuserid = userdetail.userid;
		this.userid = userdetail.userid;
		this.user_type = userdetail.utype;

		this.reportname = this.$t('warehouseRacks.productRackListFile')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient") !=='undefined')
		{
		console.log("==============>")
		this.getMerchantData()
		this.getsubinventory()
		}
		if (localStorage.getItem("selectedWarehouse")!== 'undefined')
		{
			this.getRacksZonesList()
		}
		switch (this.user_type) {
			case 'system_user':

				this.showSelectWarehouse = true;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getWarehouseList();
				// this.getClientList();
				// this.getProductRackData();
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouse = userdetail.warehouseid;
				this.warehouseid = userdetail.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				this.getProductRackData();
				this.getRacksZonesList()
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			//
			//onsole.log(newValue+"===============in event")
			// Perform any other actions needed
			this.getRacksZonesList();
		  });
	},
	methods: {
		selectMerchant(data) {
			this.selectedmerchant = data;
			this.Merchant = data.value;
		},
		jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = [], dataFilter = []) {

			var csvData = '';
			//Header
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			csvData += ''
			Object.entries(dataFilter).forEach(([k, v]) => {
				csvData += k + ':' + v + ','
			})
			csvData += '\r\n'
			csvData += '\r\n'
			//Fields
			for (let key in data[0]) {
				if (skipFilter.indexOf(key) == -1)
					csvData += csvfield[key] + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';
			//Data
			data.map(function (item) {
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						var escapedCSV = item[key] + ''; // cast Numbers to string
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilter.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
							else
								csvData += escapedCSV + ',';
						}
					}
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			})
			//Footer
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n');
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData;
		},

		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime);
			download(blob, filename, mime);
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			let bstr = atob(base64);
			let n = bstr.length;
			let u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = this.totalPage = 0;

		// 		if (this.warehouseid)
		// 			this.input = ({
		// 				warehouseid: this.warehouseid,
		// 			});
		// 		else {
		// 			this.input = {};
		// 		}
		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;

		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },


		// getWarehouseList() {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;
		// 	this.input = ({
		// 		'clientid': this.client,
		// 	});
		// 	axios({
		// 		method: 'POST',
		// 		'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 		'data': this.input,
		// 		headers: {
		// 			'Authorization': 'Bearer ' + myStr
		// 		}
		// 	})
		// 		.then(result => {
		// 			this.listWarehouseData = result.data.data;
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// },

		getMerchantData() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {

					this.listMerchantData = result.data;

					//  this.merchantList.push({
					//       value:'',text: this.$t('common.selectMerchantPlaceHolder')}
					//  )
					for (var i = 0; i < this.listMerchantData.length; i++) {
						this.merchantList.push({
							'value': this.listMerchantData[i].merchantid,
							'text': this.listMerchantData[i].merchantname
						});
					}
				}, error => {
					console.error(error);
				})
		},
		getsubinventory() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			this.input = ({
				'clientid': localStorage.getItem("selectedClient"),
				'inventoryname': '',
				'limit': 10,
				'offset': 0
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'GetInventoryList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.getsubinventorydata = result.data.data;
				}, error => {
					console.error(error)
				})

		},

		// clientSelected() {
		// 	//	console.log("slee")
		// 	this.getsubinventory()
		// 	if (this.clientid != this.client || this.clientid == this.client) {
		// 		this.clientid = this.client;
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.selectedmerchant = {}
		// 			this.merchantList = [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }]
		// 			this.Merchant = ''
		// 			this.getWarehouseList();
		// 			this.getMerchantData();
		// 			console.log(this.merchantList)
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				//this.merchantList=[]
		// 				this.warehouse = ''

		// 			}
		// 		} else {
		// 			this.merchantList = [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }]
		// 			this.selectedmerchant = {}
		// 			this.Merchant = ''
		// 			this.getMerchantData()



		// 			// if (this.warehouseid && this.clientid)
		// 			// 	this.getProductRackData();
		// 		}
		// 	}
		// 	this.listRackinData = [];
		// 	this.pageno = this.totalPage = 0;
		// 	this.rackuti = ''
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {

		// 			// this.getProductRackData();
		// 			this.getRacksZonesList()
		// 		} else {

		// 			this.getClientList();
		// 			this.getRacksZonesList()
		// 		}
		// 	}
		// },
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getAuditListForXLS(3)
			}
		},
		async getRacksZonesList() {
			try {
				if (localStorage.getItem("selectedWarehouse") == 'undefined') {

					this.$alertify.error(this.$t('common.warehouseError'))

					return false;
				}
				this.listZoneData = [];
				this.searchzone = '';
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '')
				if (this.warehouseid) {
					this.isLoading = true
					console.log("kkkkkkkllll");
					this.listZoneData = []
					this.isLoading = true
					var userToken = window.localStorage.getItem('userToken')
					var myStr = userToken.replace(/"/g, '')
					let result = await axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getZonesByWarehouse',
						'data': {
							warehouseid: localStorage.getItem("selectedWarehouse")
						},
						'headers': {
							'Authorization': 'Bearer ' + myStr
						}
					})
					this.listZoneData = result.data.data.data;
					this.isLoading = false
				}
			} catch (err) {
				console.log(err);
			}

		},

		getAuditListForXLS(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			//console.log("in csv3")
			var dataFilter = {};
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';


			this.input = ({
				limit: this.pageLimit,
				offset: (this.currentPage - 1) * 50,
				merchant: this.Merchant,
				warehouseid: localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				racktype: this.racktype,
				rackno: this.rackno.trim(),
				sectionid: this.sectionid,
				lineno: this.lineno,
				csvData: csvCheck,
				userid: this.userid,
				rackuti: this.rackuti,
				subinventory: this.subinventory,
				zoneid:this.searchzone,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getProductRackList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						//console.log(result.data.data )
						if (result.data.data) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls[this.$t('warehouseRacks.warehouseID')]='warehouseid',
							this.csvFieldsForXls[this.$t('warehouseRacks.clientId')]='clientid',
							this.csvFieldsForXls[this.$t('common.merchant')]='merchantname',
							this.csvFieldsForXls[this.$t('warehouseRacks.rackNo')]='rackno',
							this.csvFieldsForXls[this.$t('warehouseRacks.rackSequence')]='racksequence',
							this.csvFieldsForXls[this.$t('warehouseRacks.sectionId')]='sectionid',
							this.csvFieldsForXls[this.$t('warehouseRacks.LineNo')]='lineno',
							this.csvFieldsForXls[this.$t('warehouseRacks.rackType')]='racktype',
							this.csvFieldsForXls[this.$t('warehouseRacks.createdby')]='createdby',
							this.csvFieldsForXls[this.$t('warehouseRacks.createdDate')]='createddate',
							this.csvFieldsForXls[this.$t('warehouseRacks.status')]='status',
							this.csvFieldsForXls[this.$t('warehouseRacks.rackCapacity')]='rackcapacity',

							this.listReportDataforxls = result.data.data;
							//console.log(this.listReportDataforxls)
						} else {
							if (result.data.status == true) {
								this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					}

				}, error => {
					console.error(error);
				})
		},

		selectClient()
		{
			if (this.rackuti == "Not Utilized")
			{
				return ""
			}
			else{
				return localStorage.getItem("selectedClient")
			}
		},


		// get Product Rack list
		getProductRackData(csvCheck = 0) {
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;

			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.currentPage = 1;
			}

			this.input = ({
				limit: this.pageLimit,
				offset: (this.currentPage - 1) * 50,
				merchant: this.Merchant,
				warehouseid: localStorage.getItem("selectedWarehouse"),
				clientid: this.selectClient(),
				racktype: this.racktype,
				rackno: this.rackno.trim(),
				sectionid: this.sectionid,
				lineno: this.lineno,
				csvData: csvCheck,
				userid: this.userid,
				rackuti: this.rackuti,
				subinventory: this.subinventory,
				zoneid:this.searchzone,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getProductRackList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {

					if (csvCheck == 1) {
						if (result.data.data.length > 0) {
							console.log("0")
							this.listProductRackDataCsv = [];
							this.csvFields = {
								'warehouseid': this.$t('warehouseRacks.warehouseID'),
								'clientid': this.$t('warehouseRacks.clientId'),
								'merchantname': this.$t('common.merchant'),
								'rackno': this.$t('warehouseRacks.rackNo'),
								'racksequence': this.$t('warehouseRacks.rackSequence'),
								'sectionid': this.$t('warehouseRacks.sectionId'),
								'lineno':  this.$t('warehouseRacks.LineNo'),
								'racktype': this.$t('warehouseRacks.rackType'),
								'createdby': this.$t('warehouseRacks.createdby'),
								'createddate': this.$t('warehouseRacks.createdDate'),
								'status': this.$t('warehouseRacks.status'),
								'rackcapacity': this.$t('warehouseRacks.rackCapacity'),

							};
							var dateFilter = ['createddate'];
							var skipFilter = ['id', 'rackdimension', 'merchantid', 'modifiedby', 'modifieddate', 'subinventory', 'zoneid'];
							this.listProductRackDataCsv = result.data.data;
							this.jsonToCSV(this.$t('warehouseRacks.productRackListFile'), this.listProductRackDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);
						}
						else {

							if (result.data.status == true) {
								this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
							}
							else if (result.data.data.length == true) {
								this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
							}
							else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					} else {

						this.listProductRackData = result.data.data;

						this.totalCount = result.data.count
						this.resultCount = result.data.count;
						if (this.totalCount < 50) {
							this.totalPage = 1
						} else {
							this.totalPage = Math.ceil(this.totalCount / 50);
						}

						// this.totalRows = result.data.count;
						// this.resultCount = result.data.count
						// if (this.totalRows < this.perPage) {
						// 	this.pageCount = 1;
						// } else {
						// 	this.pageCount = Math.ceil(this.totalRows / this.perPage);
						// }
					}
					this.isLoading = false;
				},
					error => {
						console.error(error);
					})
		},

		//for search filter make offset 0
		getProductRackDatasearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getProductRackData(2);
		},

		//Call page number from pagination
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * this.perPage;
		// 	this.getProductRackData();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getProductRackData()
		},

		//Reset the Search filter
		resetForm() {
			this.subinventory = ''
			this.totalCount = 0;
			this.rackno = '';
			this.racktype = '';
			this.sectionid = '';
			this.lineno = '';
			this.Merchant = '';
			this.listProductRackData = [];
			this.searchFlag = false
			this.selectedmerchant = {}
			this.searchzone=''
			// this.merchantList = [{ value: '', text: this.$t('common.merchantPlaceholder') }]
			this.rackuti = '';
			// this.merchantList=[]
			this.$validator.reset();
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
			// this.getWarehouseList();
		},
		async validatevalues() {
			try {
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.getProductRackDatasearch();
					} else {
						console.log("not valid")
					}
				})
			}
			catch (err) {
				this.isLoading = false;
				this.$alert(err, "", "error");
				console.log(err);
			}
		},
		zonelist()
		{
			return JSON.parse(window.localStorage.getItem("selectedZones"))
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/components/productrackmaster/productrackmaster.component.js